import { TemplatePage } from './types';

const architecturePage: TemplatePage = {
  header: {
    color: '#C5D7E3',
    icon: 'images/video-templates/architecture_design.jpg',
    title: 'Architecture & Design Video Templates Collection',
    title_meta: '50+ Free and Customizable Design Video Templates',
    description_meta:
      'Share your shining interior architectural concepts, design ideas, and home decorating inspiration via ' +
      'stylish videos. Explore the collection of 50+ video templates for architects and decorators.',
    description:
      'A collection of video templates for those who breathe and live architecture and interior design. Promote ' +
      'your designing services or architectural firm. Share your passion for creating more functional and ' +
      'aesthetically pleasing environments.'
  },
  footer: {
    category: 'Architecture & Design',
    description:
      'Customizable video templates help you significantly speed up the video production process. It’s easy to ' +
      'adopt any template to your specific use case and message. All you need to do is replacing the sample ' +
      'footage and entering your texts. Unlimited branding possibilities allow you to create your unique video ' +
      'content and get it ready for sharing in minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'Architecture & Design Video Templates',
      search: { category: '/Industries/Interior Design' }
    },
    {
      type: 'stocks',
      title: 'architecture',
      search: { name: 'architecture design' }
    },
    { type: 'calendar' }
  ]
};

export default architecturePage;
